module.exports = __webpack_public_path__ + "img/ic-exterieur21h.b278616c.svg";